'use client';

import { Suspense, type ReactNode } from 'react';

import { AccountBreadcrumbs } from '@eliadmin/core/src/components/nt/account/shell/account-breadcrumbs';
import { AccountCompactNav } from '@eliadmin/core/src/components/nt/account/shell/account-compact-nav';
import { useAccountPage } from '@eliadmin/core/src/components/nt/account/shell/account-pages';
import { AccountSidebar } from '@eliadmin/core/src/components/nt/account/shell/account-sidebar';

/**
 * Frame of the account pages (Figma „Section · Moje konto“ 205:11185): padding 40 / 200 / 40,
 * the breadcrumbs, 24 px below them the 314 px „Account / Sidebar“ and the content column 24 px
 * apart (990 px at 1728). 1024–1279 px keep the structure with a narrower sidebar; under 1024 px
 * the sidebar becomes the compact account navigation above the content. The content column is a
 * size container, so the views lay their rows out by its width.
 */
export function AccountShell({ children }: { children: ReactNode }) {
  const { page, isReturn } = useAccountPage();
  const current = page?.key;

  return (
    <section className="custom-section pb-14 pt-6 md:pb-10 md:pt-10">
      <div className="custom-container flex flex-col gap-4 md:gap-6">
        <Suspense fallback={null}>
          <AccountBreadcrumbs page={page} isReturn={isReturn} />
        </Suspense>
        <div className="grid grid-cols-[minmax(0,1fr)] items-start gap-6 lg:grid-cols-[264px_minmax(0,1fr)] xl:grid-cols-[314px_minmax(0,1fr)]">
          <aside className="hidden lg:block">
            <AccountSidebar current={current} />
          </aside>
          <div className="min-w-0 lg:hidden">
            <AccountCompactNav current={current} />
          </div>
          <div className="flex min-w-0 flex-col @container">{children}</div>
        </div>
      </div>
    </section>
  );
}
